import { LoanOfficerService, LoanOfficerProvider, HttpService } from '@lk/api'

export const makeLoanOfficerService = (http: HttpService, baseUrl: string): LoanOfficerService =>
  new LoanOfficerService(new LoanOfficerProvider(http, baseUrl))
